function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M63.333 67.167H16.667V30.5h46.666v36.667zm-10-60v6.666H26.667V7.167H20v6.666h-3.333A6.667 6.667 0 0010 20.5v46.667a6.667 6.667 0 006.667 6.666h46.666A6.667 6.667 0 0070 67.167V20.5a6.667 6.667 0 00-6.667-6.667H60V7.167h-6.667zM36.267 43.833H24.233l9.734 7.034-3.7 11.5 9.733-7.1 9.733 7.1L46 50.9l9.733-7.067h-12L40 32.367l-3.733 11.466z",
  fill: "#DFE8F6"
});

function SvgImage3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/image3.4069d100.svg";
export { SvgImage3 as ReactComponent };